var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slot",class:[
    { 'slot--selected-left': _vm.isSelectedLeft && !_vm.isSelectedRight },
    { 'slot--selected-right': _vm.isSelectedRight && !_vm.isSelectedLeft },
    { 'slot--selected': _vm.isSelectedRight && _vm.isSelectedLeft }
  ]},[_c('div',{class:`slot__area ${_vm.slotLeftAreaClasses}`}),_c('div',{class:`slot__area ${_vm.slotRightAreaClasses}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }